import styled from 'styled-components'

export const Heading = styled.h3`
  font-weight: bold;
  margin: 0.5em;
`

export const Container = styled.div`
  display: flex;
  padding: 1em;
  flex-direction: column;
`

export const FormFields = styled.div`
  display: flex;
  flex-direction: row;
`
